import {ValidatorInterface} from './ValidatorInterface';
import {AbstractValidator, ValidatorObject} from './AbstractValidator';
import {sprintf} from 'sprintf-js';
import { Text } from "@/Models/Shapes/Text";

/**
 * Validator that checks if the value is equal to or lower than the set maximum amount for texts.
 */
export class MinimumTextValue extends AbstractValidator implements ValidatorInterface {
	declare instance: Text;

	/**
	 * Constructor.
	 *
	 * @param {ValidatorObject} options
	 */
	constructor( options: ValidatorObject ) {
		super( options );

		if ( this.dimension !== 'text' ) {
			throw new Error( 'The MinimumTextValue validator can only be used on the text dimension.' );
		}

		if ( ! ( this.instance instanceof Text ) ) {
			throw new Error( 'The MinimumTextValue validator can only be used on instances of Text shapes.' );
		}

		this.dimension = this.getDimension();
		const value = this.getDimensionValue();

		if ( typeof value !== 'number' ) {
			throw new Error( 'The MinimumTextValue validator can only be used on numbers.' );
		}

		this.value = value;
	}

	getDimension(): string {
		return this.instance.getDesiredDimension() === 'width' ? 'height' : 'width';
	}

	/**
	 * @inheritDoc
	 */
	getMessage(): string {
		const { dimensions } = this.getValidatorTranslationStrings();

		return sprintf( dimensions.text.sheet.min, this.minimum, 'cm' );
	}

	/**
	 * @inheritDoc
	 */
	isValid(): boolean {
		if ( typeof this.value !== 'number' ) {
			return false;
		}

		return this.value >= this.minimum;
	}
}
